(function () {
    'use strict';
    /*
     * Copyright (c) 2014-17 In Hand Health.
     * All rights reserved.
     */

    /**
     * @description A service that facilitates creating and maintaining a {@link ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config}
     * object for an {@link ihh-common-web.ihh-item-chooser.ihh-item-chooser} directive.
     * @ngdoc service
     * @memberOf ihh-common-web.ihh-item-chooser
     * @name ItemChooserSvc
     */
    angular
        .module('ihh-common-web')
        .service('ItemChooserSvc', ItemChooserSvc);

    ItemChooserSvc.$inject = ['$location', '_', 'IhhArrays', 'MemorySvc', 'ItemChooserConstants', 'RestResources'];

    function ItemChooserSvc($location, _, IhhArrays, MemorySvc, ItemChooserConstants, RestResources) {
        var theService = this;

        /**
         * Creates and returns a new config object for an item chooser.
         * @ngdoc method
         * @name createConfig
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
         * @param {String} STATE_KEY a string contant used as a key to save/retrieve the state; must be unique across all item choosers
         * @param {$resource} resource an AngularJS $resource object used to query items, or something that acts similarly
         * @param {String} errPrefix a string to prepend to REST error messages
         * @return {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config} the newly created <code>Config</code> object
         */
        theService.createConfig = function(STATE_KEY, resource, errPrefix) {
            return new Config(STATE_KEY, resource, errPrefix);
        };

        /**
         * Defines a callback function to get called when an item is selected.
         * @ngdoc callback
         * @name selectedFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Object} item the selected item
         */

        /**
         * Defines a callback function to get called whenever an item is added to the item chooser after being queried.
         * @ngdoc callback
         * @name processItemFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Object} item the selected item
         */

        /**
         * Defines a callback function to get called to provide a link string to follow when an item is selected.
         * @ngdoc callback
         * @name getLinkFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Object} item the selected item
         * @return {String} the link string; if it contains a hash (#) then it is considered a local link in the app
         */

        /**
         * Defines a callback function to get called when an a modal item chooser is canceled.
         * @ngdoc callback
         * @name canceledFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         */

        /**
         * Defines a callback function that can get called in response to user input on an item.
         * @ngdoc callback
         * @name itemFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Function} event the event that triggered the quick view
         * @param {Object} item the item
         */

        /**
         * Defines a configuration object for use by the item chooser directive.
         * @ngdoc type
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
         * @name Config
         * @property {Object} actions clients can hang arbitrary functions off this object for their own use
         * @property {Function} selectedFn called when an item is selected
         * @property {Function} canceledFn called when select is canceled, only in a modal item chooser
         * @param {String} STATE_KEY a string contant used as a key to save/retrieve the state; must be unique across all item choosers
         * @param {$resource} resource an AngularJS $resource object used to query items
         * @param {String} errPrefix a string to prefix to REST error messages
         */
        function Config(STATE_KEY, resource, errPrefix) {
            var dirty = false;

            // A monotonically increasing index used to detect whether a response is for the latest request.
            var requestIndex = 0;

            this.filterOptions = [];
            this.sortOptions = [];
            this.itemProperties = {
                name: {
                    singular: '',
                    plural: ''
                },
                hasThumbnail: false
            };

            this.who = [];
            this.transclude = false;
            this.templateUrl = ItemChooserConstants.DEFAULT_TEMPLATE_URL;
            this.modalHeight = '60vh';
            this.customStyle = {};
            this.overheadControlsOnly = false;
            this.localManipOnly = false;
            this.searchable = true;
            this.noLimit = false;

            this.items = [];
            this.customLoading = {};
            this.customLoading.promise = this.items.$promise;

            this.extraQueryParams = {};

            this.actions = {};

            this.state = {
                sortReverse: false,
                filters: {}
            };

            this.getStateKey = function() {
                return STATE_KEY;
            };

            this.getResource = function() {
                return resource;
            };

            this.reportError = function (err) {
                RestResources.reportRestError(errPrefix, err);
            };

            /**
             * Answers whether the <code>Config</code> has been marked dirty.
             * @ngdoc method
             * @name getDirty
             * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
             */
            this.getDirty = function() {
                return dirty;
            };

            /**
             * Answers whether the <code>Config</code> has been marked dirty.
             * @ngdoc method
             * @name getDirty
             * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
             * @param {Boolean} [value] the dirty value to set
             */
            this.setDirty = function(value) {
                if (angular.isDefined(value)) {
                    dirty = value;
                }
                else {
                    dirty = true;
                }
            };

            /*
             * (private) Increments and then returns the current request index; used for matching query requests with results.
             * @ngdoc method
             * @private
             * @name incRequestIndex
             * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
             * @returns {Number} the current request index, after incrementing
            */
            this.incRequestIndex = function() {
                requestIndex++;
                return requestIndex;
            };

            /*
             * (private) Returns the current request index; used for matching query requests with results.
             * @ngdoc method
             * @private
             * @name getRequestIndex
             * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
             * @returns {Number} the current request index
            */
            this.getRequestIndex = function() {
                return requestIndex;
            };
        }

        /**
         * Adds a sort option to the item chooser, which results in two choices in the dropdown, one for ascending and one for descending.
         * @ngdoc method
         * @name addSortOption
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {String} kind a string contstant identifying the kind of sort
         * @param {String} label the display label for the sort
         * @param {String} property the property in the item being sorted on
         * @param {Object} styles an object containing styles to apply to the sort
         */
        Config.prototype.addSortOption = function(kind, label, property, styles) {
            this.sortOptions.push(new SortOption(kind, label, property, styles));
        };

        /**
         * Removes all the filter options from the item chooser.
         * @ngdoc method
         * @name clearFilterOptions
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         */
        Config.prototype.clearFilterOptions = function() {
            this.filterOptions = [];
        };

        /**
         * Adds a filter option to the item chooser, resulting in a dropdown for that filter.
         * @ngdoc method
         * @name addFilterOption
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {String} id a unique ID for the filter
         * @param {String} label the display label for the filter
         * @param {String} displayProp the property for displaying an option value in the dropdown
         * @param {String} matchProp the property for matching an option value
         * @param {String} itemProp the property in the item to match to the filter, if local, or the name of the query parameter to set otherwise
         * @param {String} sortProp the property for sorting the filter options; if not provided the options are not sorted
         * @param {Object[]} values the objects enumerating the possible values; with the properties as specified above
         */
        Config.prototype.addFilterOption = function(id, label, displayProp, matchProp, itemProp, sortProp, values) {
            this.filterOptions.push(new FilterOption(id, label, displayProp, matchProp, itemProp, sortProp, values));
        };

        /**
         * Removes all the who (radio button) options from the item chooser.
         * @ngdoc method
         * @name clearWho
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         */
        Config.prototype.clearWho = function() {
            this.who = [];
        };

        /**
         * Adds a who (radio button) option to the item chooser.
         * @ngdoc method
         * @name addWho
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {String} id a unique ID for the who filter
         * @param {String} label the display label for the who filter
         * @param {Object[]} property a map of property/value pairs to be added to the query to effect the who filter
         * @param {Bolean} [isDefault] indicates the who item should be the default
         * @param {Number} [group] a group number for grouping radio buttons
         */
        Config.prototype.addWho = function(id, label, property, isDefault, group) {
            this.who.push({
                id: id,
                label: label,
                property: property,
                group: group
            });

            if (isDefault) {
                this.defaultWhose = id;
            }
        };

        /**
         * Sets some properties that affect item chooser display.
         * @ngdoc method
         * @name setItemProperties
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {String} singular the singular label for the kind of item being displayed
         * @param {String} plural the plural label for the kind of item being displayed
         * @param {Boolean} hasThumb indicates whether to display a thumbnail for each item
         */
        Config.prototype.setItemProperties = function(singular, plural, hasThumb) {
            this.itemProperties = {
                name: {
                    singular: singular,
                    plural: plural
                },
                hasThumbnail: !!hasThumb
            };
        };

        /**
         * Sets extra query parameters from the caller. They are passed to the resource during query.
         * @ngdoc method
         * @name setExtraQueryParams
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Object} extraQueryParams the extra query parameters to set
         */
        Config.prototype.setExtraQueryParams = function(extraQueryParams) {
            this.extraQueryParams = extraQueryParams ? extraQueryParams : {};
        };

        /**
         * Sets an array of objects that specify chooser items to suppress from the item chooser results. Items match by their "id"
         * asstribute.
         * @ngdoc method
         * @name setSuppressedItems
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Object[]} theItems the items to suppress
         */
        Config.prototype.setSuppressedItems = function(theItems) {
            this.suppressedItems = theItems;
        };

        /**
         * Sets height of the item chooser when it is
         * @ngdoc method
         * @name setModalHeight
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {String} height the height to set, e.g. '50px'
         */
        Config.prototype.setModalHeight = function(height) {
            this.modalHeight = height;
        };

        /**
         * Sets whether to only display overhead controls (
         * @ngdoc method
         * @name setOverheadControlsOnly
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Boolean} overheadControlsOnly the value to set for the flag
         */
        Config.prototype.setOverheadControlsOnly = function(overheadControlsOnly) {
            this.overheadControlsOnly = !!overheadControlsOnly;
        };

        /**
         * Sets custom styles for the iten chooser.
         * @ngdoc method
         * @name setCustomStyle
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Object} styles the styles to set for the item chooser
         */
        Config.prototype.setCustomStyle = function(styles) {
            this.customStyle = styles;
        };

        /**
         * Sets custom styles for the iten chooser.
         * @ngdoc method
         * @name setCustomLayout
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {String} layoutId an identifier for a custom layout; currently only supports 'grid'
         */
        Config.prototype.setCustomLayout = function(layoutId) {
            this.layout = layoutId;
        };

        /**
         * Sets a custom loading wait image for the iten chooser.
         * @ngdoc method
         * @name setCustomLoading
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {String} templateUrl the URL to the custom loading image
         */
        Config.prototype.setCustomLoading = function(templateUrl) {
            this.customLoading = {
                templateUrl: templateUrl,
                promise: this.items.$promise
            };
        };

        /**
         * Sets a custom item template for the item chooser.
         * @ngdoc method
         * @name setCustomTemplate
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {String} templateUrl the URL to the custom item template image
         */
        Config.prototype.setCustomTemplate = function(templateUrl) {
            this.templateUrl = templateUrl;
        };

        /**
         * Sets whether the item chooser uses transclusion for each item, rather than a template (custom or default).
         * @ngdoc method
         * @name setTransclude
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Boolean} transclude the transclude flag
         */
        Config.prototype.setTransclude = function(transclude) {
            this.transclude = !!transclude;
        };

        /**
         * Sets whether the item chooser has a full text search option.
         * @ngdoc method
         * @name setSearchable
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Boolean} searchable indicates whether to enable full text search
         */
        Config.prototype.setSearchable = function(searchable) {
            this.searchable = !!searchable;
        };

        /**
         * Sets a function that gets called on each item in the query result when it returns. Typically overridden to decorate the
         * item, but may return a completely different replacement item. The returned item is added (with no duplicates) to the item
         * chooser item array. If not set, then the item chooser simply uses the item as queried.  In particular, this function can
         * be used to decorate an item with attributes significant to the item chooser, as follows:
         * <ul>
         * <li>link -- used as a link to follow when the item is clicked</li>
         * <li>thumbnailUrl -- used to display a thumbnail for the item</li>
         * @ngdoc method
         * @name setProcessItemFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config.setProcessItemFn} processItemFn the function to set
         */
        Config.prototype.setProcessItemFn = function(processItemFn) {
            this.processItem = processItemFn;
        };

        /**
         * Sets a function that gets called when an item is selected. If this function is set, then the link function and any
         * <code>item.link</code> attribute are ignored.
         * @ngdoc method
         * @name setSelectedFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config.selectedFn} selectedFn the function to set
         */
        Config.prototype.setSelectedFn = function(selectedFn) {
            this.selectedFn = selectedFn;
        };

        /**
         * Sets a function that gets called when a modeal item chooser is canceled.
         * @ngdoc method
         * @name canceledFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config.canceledFn} canceledFn the function to set
         */
        Config.prototype.setCanceledFn = function(canceledFn) {
            this.canceledFn = canceledFn;
        };

        /**
         * Sets a function to be called to provide a link string to follow when an item is selected. Only one or the other of the
         * link and selected functions should be set. If this function is set, then any <code>item.link</code> attribute added by
         * <code>processItem</code> is ignored.
         * @ngdoc method
         * @name setGetLinkFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config.getLinkFn} getLinkFn the function to set
         */
        Config.prototype.setGetLinkFn = function(getLinkFn) {
            this.getLink = getLinkFn;
        };

        /**
         * Sets the picker's local manipulation only mode. When in this mode, all filters and sorts are done locally, and the data
         * is not re-queried.
         * @ngdoc method
         * @name setLocalManipulationMode
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Boolean} flag the value to set for the flag
         */
        Config.prototype.setLocalManipulationMode = function(flag) {
            this.localManipOnly = flag;
        };

        /**
         * Sets the picker to be in "drag mode", typically used on a page to drag onto another component to edit it.  Drag mode
         * cannot be reset once set.
         * @ngdoc method
         * @name enableDragMode
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         */
        Config.prototype.enableDragMode = function() {
            this.dragEnabled = true;
            this.editFlag = false;
            this.editOverride = true;
            this.setModalHeight('727px');
        };

        /**
         * Sets whether the picker that is in drag mode has quick view enabled, allowing the user to click a small icon on the item
         * to trigger a modal view of the item.
         * @ngdoc method
         * @name setQuickViewEnabled
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Boolean} quickViewEnabled the value to set for the flag
         */
        Config.prototype.setQuickViewEnabled = function(quickViewEnabled) {
            this.quickViewEnabled = !!quickViewEnabled;
        };

        /**
         * Sets a function that gets called when the quick view icon is pressed, to display the quick view (typically a modal).
         * @ngdoc method
         * @name setQuickViewFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config.itemFn} quickViewFn the function to call on quick view
         */
        Config.prototype.setQuickViewFn = function(quickViewFn) {
            this.displayQuickView = quickViewFn;
        };

        /**
         * Sets whether the picker that is in drag mode has quick add enabled, allowing the user to click a small icon on the item
         * to trigger adding it to some other component.
         * @ngdoc method
         * @name setQuickAddEnabled
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Boolean} quickAddEnabled the value to set for the flag
         */
        Config.prototype.setQuickAddEnabled = function(quickAddEnabled) {
            this.quickAddEnabled = !!quickAddEnabled;
        };

        /**
         * Sets a function that gets called when the quick add action is triggered by the user.
         * @ngdoc method
         * @name setQuickAddFn
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config.itemFn} quickAddFn the function to call on quick add
         */
        Config.prototype.setQuickAddFn = function(quickAddFn) {
            this.quickAdd = quickAddFn;
        };

        /**
         * Watches the state of the <code>Config</code>, saving it to local storage whenever it changes.
         * @ngdoc method
         * @name maintainState
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Object} $scope the controller scope
         */
        Config.prototype.maintainState = function($scope) {
            var theConfig = this;
            $scope.$watch(function( /*$scope*/ ) {
                return theConfig.state;
            }, function(newVal, oldVal) {
                if (newVal !== oldVal) {
                    MemorySvc.memorize(MemorySvc.LOCAL, theConfig.getStateKey(), newVal);
                }
            }, true);
        };

        /**
         * Gets the next page of results, and adds them to the picker. Discards any present values if the config is dirty.
         * @ngdoc method
         * @name nextPage
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Boolean} all if truthy, indicates to retrieve all remaining records without limit
         */
        Config.prototype.nextPage = function(all) {
            var theConfig = this;

            if (theConfig.getDirty()) {
                theConfig.items = [];
                theConfig.allItemsRetrieved = false;
            }
            else {
                theConfig.items = theConfig.items || [];
            }

            theConfig.items.$resolved = false;

            var params = getQueryParams(theConfig, all || this.noLimit);

            // This closure saves the incremented request index at the time of the request, so that the callback function can check
            // when the request comes back to make sure it was the latest request.
            (function() {
                var requestIndex = theConfig.incRequestIndex();
                var limit = angular.isDefined(params.limit) ? params.limit : RestResources.getQueryLimit();
                var resume = theConfig.resume;

                var queryResults = theConfig.getResource().query(params, function(queryResult) {

                    // verify that we are using the last request and do nothing if we aren't.
                    if (requestIndex === theConfig.getRequestIndex()) {
                        theConfig.allItemsRetrieved = resume === queryResult.resume || queryResult.items.length < limit;
                        theConfig.resume = queryResult.resume;

                        angular.forEach(queryResult.items, function(item) {
                            var theItem = theConfig.processItem ? theConfig.processItem(item) : item;
                            IhhArrays.addWithNoDup(theConfig.items, theItem);
                        });

                        theConfig.setDirty(false);
                        theConfig.items.$resolved = true;
                        theConfig.items.$promise = {};
                    }
                }, theConfig.reportError);

                theConfig.items.$promise = queryResults.$promise;
            })();

            theConfig.customLoading.promise = theConfig.items.$promise;
        };

        /**
         * Recalls memorized config state from local storage.
         * @ngdoc method
         * @name recallState
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         */
        Config.prototype.recallState = function() {
            var memory = MemorySvc.recall(MemorySvc.LOCAL, this.getStateKey());
            checkMemory(this, memory);
            this.state = memory || this.state;

            if (angular.isUndefined(this.state.sort)) {
                if (angular.isDefined(this.defaultSort) && this.defaultSort !== null) {
                    this.state.sort = this.defaultSort;
                }
                else if (angular.isArray(this.sortOptions) && this.sortOptions.length > 0) {
                    this.state.sort = this.sortOptions[0].property;
                }
            }

            if (angular.isUndefined(this.state.sortReverse)) {
                this.state.sortReverse = false;
            }

            if (angular.isArray(this.who)) {
                if (angular.isDefined(this.defaultWhose) && this.defaultWhose !== null) {
                    this.state.whose = this.state.whose || this.defaultWhose;
                }
                else if (this.who.length > 0) {
                    this.state.whose = this.state.whose || this.who[0].id;
                }
            }

            this.state.searchTerms = this.state.searchedTerms;
        };

        /**
         * Clears the content of the chooser, as well as any uncommitted search terms. It does not get a new page of results, but
         * does mark the config as dirty.
         * @ngdoc method
         * @name clear
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {boolean} force if truthy, forces the clear resume even if the chooser is local manipulation only
         */
        Config.prototype.clear = function(force) {
            if (!this.localManipOnly || force) {
                this.state.searchTerms = this.state.searchedTerms;
                this.resume = undefined;
                this.allItemsRetrieved = false;
                this.items.$resolved = false;
                this.items.$promise = new Object();
                this.items.splice(0, this.items.length);
                this.setDirty(true);
            }
        };

        /**
         * Clears the resume state and gets a brand new first page of results.
         * @ngdoc method
         * @name clearResume
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {boolean} force if truthy, forces the clear resume even if the chooser is local manipulation only
         */
        Config.prototype.clearResume = function(force) {
            if (!this.localManipOnly || force) {
                this.clear(force);
                this.nextPage();
            }
        };

        /**
         * Clears clears all filters and searches, and gets a brand new first page of results.
         * @ngdoc method
         * @name clearResume
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         */
        Config.prototype.clearAll = function() {
            this.state.filters = new Object();
            this.state.searchTerms = undefined;
            this.state.searchedTerms = undefined;
            this.clearResume();
        };

        /**
         * Sets the search string for the picker, but only triggers a search query if the search string is empty. Suitable for
         * calling whenever the user types in the full text search text control.
         * @ngdoc method
         * @name searchChange
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {String} searchStr the full text search string to set
         */
        Config.prototype.searchChange = function(searchStr) {
            if (searchStr === '') {
                this.state.searchedTerms = undefined;
                this.search();
            }
        };

        /**
         * Activates the current search string, and gets a brand new first page of results.
         * @ngdoc method
         * @name search
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         */
        Config.prototype.search = function() {
            this.state.searchedTerms = this.state.searchTerms;
            this.clearResume();
        };

        /**
         *
         * @param {ihh-common-web.ihh-item-chooser.sortOption} sort the sort option
         * @param {Boolean} reverse if true; answers whether to show the reverse sort option
         * @returns {Boolean} true if the sort option should be shown
         */
        Config.prototype.isShowSort = function(sort, reverse){
            if (sort.kind === ItemChooserConstants.SORT_KIND_REVERSE_ONLY) {
                return reverse;
            }

            if (sort.kind === ItemChooserConstants.SORT_KIND_CUSTOM) {
                return !reverse;
            }

            // This is to match a puzzling legacy behavior...would be good to understand and remove.  Need to figure out
            // if any callers are setting a sort option with the kind attribute undefined to suppress the reverse option.
            return !reverse || angular.isDefined(sort.kind);
        };

        /**
         * Returns whether to show the overhead sort control.
         * @returns {Boolean} true if the sort option should be shown
         */
        Config.prototype.isShowOverheadSort = function(){
            return this.overheadControlsOnly && this.sortOptions && this.sortOptions.length > 0;
        };

        /**
         * Returns whether to show the overhead filter control.
         * @returns {Boolean} true if the sort option should be shown
         */
        Config.prototype.isShowOverheadFilter = function(){
            return this.overheadControlsOnly && this.filterOptions && this.filterOptions.length > 0;
        };

        /**
         * Returns the kind (e.g. A->Z) label for the passed sort option.
         * @ngdoc method
         * @name getSortKindLabel
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.sortOption} sort the sort option
         * @param {Boolean} reverse indicates whether to return the label for reverse sort
         * @returns {String} the sort kind label
         */
        Config.prototype.getSortKindLabel = function(sort, reverse) {
            if (sort.kind === ItemChooserConstants.SORT_KIND_ALPHA) {
                if (reverse === false) {
                    return ItemChooserConstants.SORT_KIND_ALPHA_ASC;
                }
                else {
                    return ItemChooserConstants.SORT_KIND_ALPHA_DESC;
                }
            }
            else if (sort.kind === ItemChooserConstants.SORT_KIND_NUMERIC) {
                if (reverse === false) {
                    return ItemChooserConstants.SORT_KIND_NUMERIC_ASC;
                }
                else {
                    return ItemChooserConstants.SORT_KIND_NUMERIC_DESC;
                }
            }
            else if (sort.kind === ItemChooserConstants.SORT_KIND_DATE) {
                if (reverse === false) {
                    return ItemChooserConstants.SORT_KIND_DATE_ASC;
                }
                else {
                    return ItemChooserConstants.SORT_KIND_DATE_DESC;
                }
            }
            else {
                return ItemChooserConstants.SORT_KIND_NONE;
            }
        };

        /**
         * Sets the sort for the item picker.
         * @ngdoc method
         * @name setSort
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.sortOption} sort the sort option to set
         * @param {Boolean} reverse indicates whether to reverse the sort
         */
        Config.prototype.setSort = function(sort, reverse) {
            if (angular.isDefined(reverse)) {
                this.state.sortReverse = reverse;
            }
            this.state.sort = sort.property;
            this.clearResume();
        };

        /**
         * Gets the who (radio button) property by the who ID.
         * @ngdoc method
         * @name getWhoPropertyById
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {String} whoId the ID of the who record to get the property
         */
        Config.prototype.getWhoPropertyById = function(whoId) {
            if (angular.isDefined(this.who)) {
                for (var i = 0; i < this.who.length; i++) {
                    if (this.who[i].id === whoId) {
                        return this.who[i].property;
                    }
                }
            }
            return {};
        };

        /**
         * Returns the label for the currently active sort option.
         * @ngdoc method
         * @name getSortLabel
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @returns {String} the sort label
         */
        Config.prototype.getSortLabel = function() {
            var sortLabel = {
                option: 'None',
                direction: ''
            };
            if (this.state.sort && angular.isArray(this.sortOptions)) {
                for (var i = 0; i < this.sortOptions.length; i++) {
                    if (angular.isArray(this.sortOptions[i].property) && angular.isArray(this.state.sort)) {
                        if (this.sortOptions[i].property.length === this.state.sort.length) {
                            var isMatch = true;
                            for (var j = 0; j < this.state.sort.length; j++) {
                                if (this.sortOptions[i].property[j] !== this.state.sort[j]) {
                                    isMatch = false;
                                    break;
                                }
                            }
                            if (isMatch) {
                                sortLabel.option = this.sortOptions[i].label;
                                sortLabel.direction = this.getSortKindLabel(this.sortOptions[i], this.state.sortReverse);
                            }
                        }
                    }
                    else if (this.sortOptions[i].property === this.state.sort) {
                        sortLabel.option = this.sortOptions[i].label;
                        sortLabel.direction = this.getSortKindLabel(this.sortOptions[i], this.state.sortReverse);
                    }
                }
            }

            return sortLabel;
        };

        /**
         * Returns the label style for the currently active sort option.
         * @ngdoc method
         * @name getSortLabelStyle
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @returns {String} the sort label style
         */
        Config.prototype.getSortLabelStyle = function() {
            if (this.state.sort && angular.isArray(this.sortOptions)) {
                for (var i = 0; i < this.sortOptions.length; i++) {
                    if (angular.isArray(this.sortOptions[i].property) && angular.isArray(this.state.sort)) {
                        if (this.sortOptions[i].property.length === this.state.sort.length) {
                            var isMatch = true;
                            for (var j = 0; j < this.state.sort.length; j++) {
                                if (this.sortOptions[i].property[j] !== this.state.sort[j]) {
                                    isMatch = false;
                                    break;
                                }
                            }
                            if (isMatch) {
                                return this.sortOptions[i].labelStyle;
                            }
                        }
                    }
                    else if (this.sortOptions[i].property === this.state.sort) {
                        return this.sortOptions[i].labelStyle;
                    }
                }
            }
            return '';
        };

        /**
         * Returns the display string for the selected filter of the specified filter option.
         * @ngdoc method
         * @name getSelectedFilterDisplay
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.filterOption} filterOption the filter option
         * @returns {String} the display string for the filter option, or a string that indicates all if no filter is selected.
         */
        Config.prototype.getSelectedFilterDisplay = function(filterOption) {
            var filter = this.state.filters[filterOption.id];

            return filter ? filter.filterValue[filterOption.displayProperty] : 'All';
        };

        /**
         * Sets the filter value for a particular filter option, and then gets a brand new first page of results.
         * @ngdoc method
         * @name setFilter
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.filterOption} filterOption the filter option
         * @param {Object} filterValue the filter value to set for the filter option
         */
        Config.prototype.setFilter = function(filterOption, filterValue) {
            this.state.filters[filterOption.id] = {
                filterOption: filterOption,
                filterValue: filterValue
            };

            this.clearResume();
        };

        /**
         * Removes the filter value for a particular filter option, and then gets a brand new first page of results.
         * @ngdoc method
         * @name setFilter
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.filterOption} filterOption the filter option
         */
        Config.prototype.removeFilter = function(filterOption) {
            delete this.state.filters[filterOption.id];
            this.clearResume();
        };

        /**
         * Returns whether a particular filter value is selected for a filter option.
         * @ngdoc method
         * @name getSelectedFilterDisplay
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {ihh-common-web.ihh-item-chooser.filterOption} filterOption the filter option
         * @param {Object} filterValue the filter value check
         * @returns {String} true if the filter value is set for the filter option; false otherwise
         */
        Config.prototype.isFilterSelected = function(filterOption, filterValue) {
            var filter = this.state.filters[filterOption.id];

            return filter && filter.filterValue === filterValue;
        };

        /**
         * Will either change the selected item to the one given or in the case of multiple selected, add it if it is not present
         * in the array or remove it if it is. If <code>setSelectedFn</code> has been called, then the provided selected funnction
         * will be called on the item.  Otherwise, if <code>setGetLinkFn</code> has been called, then the provided get link function
         * will be used to get a link string, which will be followed.  Otherwise, if the item has a <code>link</code> attribute, then
         * it will used as a link string and followed.
         * defined, it will go to the defined path.
         * @ngdoc method
         * @name select
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Object} item the item to select
         */
        Config.prototype.select = function(item) {
            if (!angular.isArray(this.selected)) {
                this.selected = item;
                if (this.selectedFn) {
                    this.selectedFn(item);
                }
                else if (this.getLink) {
                    followLink(this.getLink(item));
                }
                else if (item.link) {
                    followLink(item.link);
                }
            }
            else {
                var isInSelected = false;
                if (angular.isArray(this.selected)) {
                    for (var i = 0; i < this.selected.length; i++) {
                        if (item === this.selected[i]) {
                            this.selected.splice(i, 1);
                            if (angular.isDefined(this.unselectedFn)) {
                                this.unselectedFn(item);
                            }
                            isInSelected = true;
                        }
                    }
                }
                if (!isInSelected) {
                    this.selected.push(item);
                    if (angular.isDefined(this.selectedFn)) {
                        this.selectedFn(item);
                    }
                }
            }
        };


        /**
         * Returns whether the passed object is selected (or in the selection if multiselect is allowed).
         * @ngdoc method
         * @name isInSelected
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Object} item the item to check
         * @return true if the item is selected
         */
        Config.prototype.isInSelected = function(item) {
            if (angular.isArray(this.selected)) {
                for (var i = 0; i < this.selected.length; i++) {
                    if (item === this.selected[i]) {
                        return true;
                    }
                }
                return false;
            }
            else {
                return item === this.selected;
            }
        };

        /**
         * Returns how many of the items in the results are shown (not hidden).
         * @ngdoc method
         * @name countShown
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @param {Object[]} results the items to check
         * @return the number of items not hidden
         */
        Config.prototype.countShown = function(results) {
            var shown = 0;
            var i;
            if (angular.isDefined(results)) {
                for (i = 0; i < results.length; i++) {
                    if (results[i].hidden !== true) {
                        shown++;
                    }
                }
            }
            return shown;
        };

        /**
         * Returns a query params object that can be used to query the full logical contents of the item chooser from the source,
         * applying all current filters and sorts, but getting all items with no limit and no resume.
         * @ngdoc method
         * @name getQueryParamsForAll
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config
         * @return {Object} the query params object
         */
        Config.prototype.getQueryParamsForAll = function() {
            var params = getQueryParams(this, true);

            delete params.resume;

            return params;
        };

        /**
         * Returns The number of days that have passed since the passed date.
         *
         * @param {Date} date the date to check
         * @param {number} days the number of days less than to consider recent
         * @returns {Boolean} true if the date is recent; false otherwise
         */
        Config.prototype.isRecent = function (date, days) {
            try {
                var millisInDate = 24 * 60 * 60 * 1000;
                var now = Date.now();
                var theDate = new Date(date);
                var diff = (now - theDate.getTime()) / (millisInDate);

                return diff >= 0.0 && diff <= days;
            }
            catch (err) {
                return false;
            }
        };

        /**
         * An object describing a single filter that can be used to limit the results.
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
         * @ngdoc type
         * @name FilterOption
         * @param {String} id An ID for the filter; must be unique in the config.
         * @param {String} label A displayable label for the filter.
         * @param {String} displayProperty The name of the property in the filter elements to display in the dropdown.
         * @param {String} matchProperty The name of the property in both the filter element and the item object to use to decide if there is a match.
         * @param {String} itemProperty The name of the property in the items being filtered. May be a single object or array of objects
         * with a matchProperty to compare to the filter matchProperty
         * @param {Object[]} values The possible values to pick from for filtering. Each value must have a value for displayProperty and matchProperty.
         * @param {String} sortProperty the name of a property to sort the options by; if not provided the options are not sorted
         */
        function FilterOption(id, label, displayProperty, matchProperty, itemProperty, sortProperty, values) {
            this.id = id;
            this.label = label;
            this.displayProperty = displayProperty;
            this.matchProperty = matchProperty;
            this.itemProperty = itemProperty;
            this.sortProperty = sortProperty;
            this.values = values;
        }

        /**
         * An object describing a sort that can be used to order the results.
         * @memberOf ihh-common-web.ihh-item-chooser
         * @ngdoc type
         * @name SortOption
         * @param {String} kind a string identifier for the kind of sort (alphabetic, numeric, etc.)
         * @param {String} label a displayable label for the sort.
         * @param {String} property the name of the property in the item list to sort by.
         * @param {Object} styles an object containing styles to apply to the sort
         */
        function SortOption(kind, label, property, styles) {
            this.kind = kind;
            this.label = label;
            this.property = property;
            this.labelStyle = styles;
        }

        /*
         * (private) Returns a query parameters object for passing to a query, from the various config settings.
         * @ngdoc method
         * @private
         * @name getQueryParams
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config} config the current config object
         * @param {Boolean} all if truthy, removes the limit from the string so that all remaining records are queried
         * @returns {String} the current sort string
        */
        function getQueryParams(config, all) {
            var paramObject = {};
            if (angular.isDefined(config.who)) {
                for (var i = 0; i < config.who.length; i++) {
                    if (config.who[i].id === config.state.whose) {
                        angular.extend(paramObject, config.who[i].property);
                        break;
                    }
                }
            }

            if (config.getDirty()) {
                config.resume = null;
            }
            paramObject.order = getSortString(config);
            processFilters(config, paramObject);
            paramObject.search = getSearch(config);
            paramObject.resume = config.resume;

            if (all) {
                paramObject.limit = 0;
            }

            angular.extend(paramObject, config.extraQueryParams);

            return paramObject;
        }

        /*
         * (private) Returns the current sort string from the config.
         * @ngdoc method
         * @private
         * @name getSortString
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config} config the current config object
         * @returns {String} the current sort string
        */
        function getSortString(config) {
            var sortString = '';
            if (angular.isDefined(config.state.sort)) {
                if (angular.isArray(config.state.sort)) {
                    for (var i = 0; i < config.state.sort.length; i++) {
                        if (i > 0) {
                            sortString += ',';
                        }
                        sortString += (config.state.sortReverse ? '-' : '') + config.state.sort[i];
                    }
                }
                else {
                    sortString += (config.state.sortReverse ? '-' : '') + config.state.sort;
                }
            }
            return sortString;
        }

        /*
         * (private) Processes the filters that are set, adding to the query params for each.  The filter option <code>itemProperty</code>
         * attribute determines the query param attribute that gets set, which is typically 'tags'.
         * @ngdoc method
         * @private
         * @name processFilters
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config} config the current config object
         * @param {Object} queryParams an object to receive query parameter attributes
         */
        function processFilters(config, queryParams) {
            if (angular.isDefined(config.state.filters)) {
                for (var i = 0; i < config.filterOptions.length; i++) {
                    var filterOption = config.filterOptions[i];
                    var filter = config.state.filters[filterOption.id];
                    if (filter) {
                        if (!queryParams[filter.filterOption.itemProperty]) {
                            queryParams[filter.filterOption.itemProperty] = filter.filterValue.id;
                        }
                        else {
                            queryParams[filter.filterOption.itemProperty] += ',';
                            queryParams[filter.filterOption.itemProperty] += filter.filterValue.id;
                        }
                    }
                }
            }
        }

        /*
         * (private) Changes the location to the link specified by the argument. If the link argument contains a hash (#) then it is
         * assumed to be an internal link, and everything up to the has is stripped off.
         * @ngdoc method
         * @private
         * @name followLink
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
         * @param {String} link the link string, which must have a hash (#)
         */
        function followLink(link) {
            var linkHashLocation;
            linkHashLocation = link.indexOf('#');
            if (linkHashLocation >= 0) {
                link = link.slice(linkHashLocation + 1);
            }
            $location.path(link);
        }

        /*
         * (private) Returns the current searched terms from the config; or undefined if there are none.
         * @ngdoc method
         * @private
         * @name getSearch
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config} config the current config object
         * @returns {Object} the current searched terms from the config; or undefined if there are none.
         */
        function getSearch(config) {
            if (angular.isDefined(config.state.searchedTerms)) {
                return config.state.searchedTerms;
            }
        }

        /*
         * (private) Evaluates a <code>Config</code> state pulled from memory against the current config, and fixes up anything
         * from memory that is not consistent with the current config, updating with defaults as needed.
         * @ngdoc method
         * @private
         * @name checkMemory
         * @memberOf ihh-common-web.ihh-item-chooser.ItemChooserSvc
         * @param {ihh-common-web.ihh-item-chooser.ItemChooserSvc.Config} config the current config object
         * @param {Object} memory the config state from memory, that might need fixed up
         * @returns {Object} the state from memory, fixed up as needed
         */
        function checkMemory(config, memory) {
            if (angular.isDefined(memory) && memory !== null && angular.isDefined(config) && config !== null) {
                // check if the remembered sorts are still available
                var hasMatchingSort = false;

                if (angular.isArray(config.sortOptions)) {
                    for (var i = 0; i < config.sortOptions.length; i++) {
                        if (_.isEqual(memory.sort, config.sortOptions[i].property)) {
                            hasMatchingSort = true;
                            break;
                        }
                    }
                    if (!hasMatchingSort) {
                        if (angular.isDefined(config.defaultSort) && config.defaultSort !== null) {
                            memory.sort = config.defaultSort;
                        }
                        else if (config.sortOptions.length > 0){
                            memory.sort = config.sortOptions[0].property;
                        }
                    }
                } // else do nothing

                // check if the remembered whose are still available
                var hasMatchingWhose = false;

                if (angular.isArray(config.who)) {
                    for (var j = 0; j < config.who.length; j++) {
                        if (memory.whose === config.who[j].id) {
                            hasMatchingWhose = true;
                            break;
                        }
                    }
                    if (!hasMatchingWhose) {
                        if (angular.isDefined(config.defaultWhose) && config.defaultWhose !== null) {
                            memory.whose = config.defaultWhose;
                        }
                        else if (config.who.length > 0){
                            memory.whose = config.who[0].id;
                        }
                    }
                } // else do nothing
            }

            return memory;
        }
    }
})();